<sbnb-profile-img [src]="senderImg" [alt]="senderName"></sbnb-profile-img>
<div class="flex flex-col items-end w-full" style="gap: 12px">
  <div class="message-card">
    <ng-content></ng-content>
  </div>
  <sbnb-timestamp *ngIf="timestamp" [timestamp]="timestamp"></sbnb-timestamp>
</div>
